import { createContext, useContext } from 'react';
import { SearchParamValue } from '../../../interfaces/paginate.interface';

interface IDriversContext {
    drivers: any;
    driver: string | null;
    pagination: { limit: number; page: number; };
    total: number;
    loading: boolean;
    errorMessage: string | null;
    fetchData: () => void;
    handleSetDriver: (driverID: string, data: any) => void;
    setDriver: (driver: string | null) => void;
    setPagination: (paginator: { limit: number; page: number; }) => void;
    handleSearchParam: (key: string, value: SearchParamValue) => void;
}

const DriversContext = createContext<IDriversContext | undefined>(undefined);

const useDriversContext = () => {
    const context = useContext(DriversContext);
    if (context === undefined) {
        throw new Error('useDrivers must be used within a DriversProvider');
    }
    return context;
};

export { DriversContext, useDriversContext };
